
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : typeof wasmJsTag !== 'undefined' && wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.Date_$external_fun' : () => new Date(),
        'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
        'kotlin.uuid.get' : (array, index) => array[index],
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
        'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
        'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
        'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
        'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
        'org.w3c.dom.Node_$external_class_get' : () => Node,
        'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
        'org.w3c.dom.Touch_$external_class_get' : () => Touch,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.dom.url.URLSearchParams_$external_fun' : (p0, isDefault0) => new URLSearchParams(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.url.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'org.w3c.dom.url.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
        'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
        'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
        'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
        'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process.env.KTOR_LOG_LEVEL,
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
        'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
        'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
        'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
        'com.dhee.shared.auth.fbCurrentUid' : () => { var u = firebase.auth().currentUser; return u ? u.uid : null; },
        'com.dhee.shared.auth.fbPhoneE164' : () => { var u = firebase.auth().currentUser; return (u && u.phoneNumber) ? u.phoneNumber : null; },
        'com.dhee.shared.auth.fbAuthReady' : () => 
            new Promise(function (resolve) {
                var unsub = firebase.auth().onAuthStateChanged(function () { unsub(); resolve(null); });
            })
            ,
        'com.dhee.shared.auth.jsStr' : (v) => (v === null || v === undefined) ? null : String(v),
        'com.dhee.shared.auth.fbGetIdToken' : (force) => { var u = firebase.auth().currentUser; return u ? u.getIdToken(force) : Promise.resolve(null); },
        'com.dhee.shared.auth.fbSignInCustom' : (token) => firebase.auth().signInWithCustomToken(token).then(function (c) { return c.user.uid; }),
        'com.dhee.shared.auth.fbSignOut' : () => firebase.auth().signOut(),
        'com.dhee.shared.config.readBuildMeta' : () => { var m = document.querySelector('meta[name="dhee-build"]'); return m ? m.getAttribute('content') : null; },
        'com.dhee.shared.data.local.wipeWebLocalStores' : () => 
            {
                try { if (globalThis.localStorage) globalThis.localStorage.clear(); } catch (e) {}
                try {
                    if (globalThis.__dheeIdb) { try { globalThis.__dheeIdb.close(); } catch (e) {} globalThis.__dheeIdb = null; }
                    if (globalThis.indexedDB) { indexedDB.deleteDatabase('dhee-db'); }
                } catch (e) {}
            }
            ,
        'com.dhee.shared.data.local.sqlJsInitPromise' : (schemaVersion) => 
            (function () {
                function freshDb() {
                    return initSqlJs({ locateFile: function (f) { return '/' + f; } }).then(function (SQL) {
                        globalThis.__dheeSQL = SQL;
                        globalThis.__dheeDb = new SQL.Database();
                        globalThis.__dheeLoadedFromPersistence = false;
                        globalThis.__dheePersistedVersion = 0;
                        return null;
                    });
                }
                function openIdb() {
                    return new Promise(function (resolve, reject) {
                        var req = indexedDB.open('dhee-db', 1);
                        req.onupgradeneeded = function () { req.result.createObjectStore('kv'); };
                        req.onsuccess = function () { resolve(req.result); };
                        req.onerror = function () { reject(req.error); };
                    });
                }
                function idbGet(db, key) {
                    return new Promise(function (resolve) {
                        try {
                            var rq = db.transaction('kv', 'readonly').objectStore('kv').get(key);
                            rq.onsuccess = function () { resolve(rq.result); };
                            rq.onerror = function () { resolve(null); };
                        } catch (e) { resolve(null); }
                    });
                }
                return openIdb().then(function (db) {
                    globalThis.__dheeIdb = db;
                    return Promise.all([idbGet(db, 'sqlite'), idbGet(db, 'schemaVersion')]).then(function (vals) {
                        var bytes = vals[0], ver = vals[1];
                        var usable = bytes && typeof ver === 'number' && ver > 0 && ver <= schemaVersion;
                        return initSqlJs({ locateFile: function (f) { return '/' + f; } }).then(function (SQL) {
                            globalThis.__dheeSQL = SQL;
                            if (usable) {
                                globalThis.__dheeDb = new SQL.Database(new Uint8Array(bytes));
                                globalThis.__dheeLoadedFromPersistence = true;
                                globalThis.__dheePersistedVersion = ver;
                            } else {
                                globalThis.__dheeDb = new SQL.Database();
                                globalThis.__dheeLoadedFromPersistence = false;
                                globalThis.__dheePersistedVersion = 0;
                            }
                            return null;
                        });
                    });
                }).catch(function (e) { return freshDb(); });
            })()
            ,
        'com.dhee.shared.data.local.readLoadedFromPersistence' : () => globalThis.__dheeLoadedFromPersistence === true,
        'com.dhee.shared.data.local.readPersistedVersion' : () => { var v = globalThis.__dheePersistedVersion; return (typeof v === 'number') ? v : 0; },
        'com.dhee.shared.data.local.sqlResetDb' : () => 
            {
                if (globalThis.__dheeDb) { try { globalThis.__dheeDb.close(); } catch (e) {} }
                globalThis.__dheeDb = new globalThis.__dheeSQL.Database();
                globalThis.__dheeLoadedFromPersistence = false;
                globalThis.__dheePersistedVersion = 0;
            }
            ,
        'com.dhee.shared.data.local.idbSavePromise' : (schemaVersion) => 
            (function () {
                try {
                    var db = globalThis.__dheeIdb;
                    if (!db || !globalThis.__dheeDb) return Promise.resolve(null);
                    var bytes = globalThis.__dheeDb.export();
                    return new Promise(function (resolve) {
                        var tx = db.transaction('kv', 'readwrite');
                        var store = tx.objectStore('kv');
                        store.put(bytes, 'sqlite');
                        store.put(schemaVersion, 'schemaVersion');
                        tx.oncomplete = function () { resolve(null); };
                        tx.onerror = function () { resolve(null); };
                        tx.onabort = function () { resolve(null); };
                    });
                } catch (e) { return Promise.resolve(null); }
            })()
            ,
        'com.dhee.shared.data.local.sqlExec' : (sql, params) => { var r = globalThis.__dheeDb.exec(sql, params); return (r && r.length > 0) ? r[0].values : null; },
        'com.dhee.shared.data.local.sqlRun' : (sql, params) => { globalThis.__dheeDb.run(sql, params); return globalThis.__dheeDb.getRowsModified(); },
        'com.dhee.shared.data.local.newJsArray' : () => [],
        'com.dhee.shared.data.local.jsSetNull' : (a, i) => { a[i] = null; },
        'com.dhee.shared.data.local.jsSetString' : (a, i, v) => { a[i] = v; },
        'com.dhee.shared.data.local.jsSetDouble' : (a, i, v) => { a[i] = v; },
        'com.dhee.shared.data.local.arrLen' : (a) => a.length,
        'com.dhee.shared.data.local.rowAt' : (a, i) => a[i],
        'com.dhee.shared.data.local.cellIsNull' : (row, i) => { var v = row[i]; return v === null || v === undefined; },
        'com.dhee.shared.data.local.cellStr' : (row, i) => { return String(row[i]); },
        'com.dhee.shared.data.local.cellNum' : (row, i) => { return Number(row[i]); },
        'com.dhee.shared.domain.quiz.jsNormalizeNfc' : (s) => s.normalize('NFC'),
        'com.dhee.shared.platform.capStart' : () => {
                var C = globalThis.__dheeCap || (globalThis.__dheeCap = {});
                C.q = []; C.active = false; C.error = null;
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { C.error = 'no_getUserMedia'; return; }
                navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1, echoCancellation: true, noiseSuppression: true } })
                .then(function (stream) {
                    var Ctx = globalThis.AudioContext || globalThis.webkitAudioContext;
                    var ctx = new Ctx();
                    var src = ctx.createMediaStreamSource(stream);
                    var node = ctx.createScriptProcessor(4096, 1, 1);
                    var ratio = ctx.sampleRate / 16000;
                    node.onaudioprocess = function (e) {
                        if (!C.active) return;
                        var input = e.inputBuffer.getChannelData(0);
                        var outLen = Math.floor(input.length / ratio);
                        if (outLen <= 0) return;
                        var out = new Uint8Array(outLen * 2);
                        for (var i = 0; i < outLen; i++) {
                            var s = input[(i * ratio) | 0];
                            if (s > 1) s = 1; else if (s < -1) s = -1;
                            var v = (s < 0 ? s * 32768 : s * 32767) | 0;
                            out[i * 2] = v & 0xFF;
                            out[i * 2 + 1] = (v >> 8) & 0xFF;
                        }
                        C.q.push(out);
                    };
                    // ScriptProcessor must be in the graph to fire; its (silent, unwritten)
                    // output goes to destination — no echo because we never fill it.
                    src.connect(node);
                    node.connect(ctx.destination);
                    C.stream = stream; C.ctx = ctx; C.node = node; C.src = src; C.active = true;
                })
                .catch(function (err) { C.active = false; C.error = String(err); });
            },
        'com.dhee.shared.platform.capDrain' : () => { var C = globalThis.__dheeCap; if (!C || !C.q || C.q.length === 0) return null; var a = C.q; C.q = []; return a; },
        'com.dhee.shared.platform.jsArrLen' : (a) => a.length,
        'com.dhee.shared.platform.jsArrAt' : (a, i) => a[i],
        'com.dhee.shared.platform.capStop' : () => {
                var C = globalThis.__dheeCap;
                if (!C) return;
                C.active = false;
                try { if (C.node) C.node.disconnect(); } catch (e) {}
                try { if (C.src) C.src.disconnect(); } catch (e) {}
                try { if (C.stream) C.stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
                try { if (C.ctx) C.ctx.close(); } catch (e) {}
                C.node = null; C.src = null; C.stream = null; C.ctx = null; C.q = [];
            },
        'com.dhee.shared.platform.jsU8Len' : (u8) => u8.length,
        'com.dhee.shared.platform.jsU8Get' : (u8, i) => u8[i],
        'com.dhee.shared.platform.audioEnsureCtx' : () => {
                var A = globalThis.__dheeAudio;
                if (!A) {
                    var Ctx = globalThis.AudioContext || globalThis.webkitAudioContext;
                    A = globalThis.__dheeAudio = { ctx: new Ctx(), next: 0, gen: 0, sources: [] };
                }
                if (A.ctx.state === 'suspended') { A.ctx.resume(); }
            },
        'com.dhee.shared.platform.audioPlayWav' : (u8) => 
            (function () {
                var A = globalThis.__dheeAudio;
                var arr = u8.buffer.slice(u8.byteOffset, u8.byteOffset + u8.byteLength);
                return A.ctx.decodeAudioData(arr).then(function (buf) {
                    return new Promise(function (resolve) {
                        var src = A.ctx.createBufferSource();
                        src.buffer = buf;
                        src.connect(A.ctx.destination);
                        A.sources.push(src);
                        src.onended = function () {
                            var idx = A.sources.indexOf(src); if (idx >= 0) A.sources.splice(idx, 1);
                            resolve(null);
                        };
                        src.start(A.ctx.currentTime);
                    });
                });
            })()
            ,
        'com.dhee.shared.platform.audioCurrentGen' : () => { var A = globalThis.__dheeAudio; return A ? A.gen : 0; },
        'com.dhee.shared.platform.audioEnqueuePcm' : (gen, u8) => {
                var A = globalThis.__dheeAudio;
                if (!A || A.gen !== gen) return;
                var n = (u8.length >> 1);
                if (n <= 0) return;
                var buf = A.ctx.createBuffer(1, n, 24000);
                var ch = buf.getChannelData(0);
                for (var i = 0; i < n; i++) {
                    var lo = u8[i * 2], hi = u8[i * 2 + 1];
                    var s = (hi << 8) | lo;
                    if (s >= 32768) s -= 65536;
                    ch[i] = s / 32768;
                }
                var src = A.ctx.createBufferSource();
                src.buffer = buf;
                src.connect(A.ctx.destination);
                var t = A.ctx.currentTime;
                var startAt = A.next > t ? A.next : (t + 0.04);
                src.start(startAt);
                A.next = startAt + buf.duration;
                A.sources.push(src);
                src.onended = function () { var idx = A.sources.indexOf(src); if (idx >= 0) A.sources.splice(idx, 1); };
            },
        'com.dhee.shared.platform.audioDrainPromise' : (gen) => 
            (function () {
                var A = globalThis.__dheeAudio;
                if (!A || A.gen !== gen) return Promise.resolve(null);
                return new Promise(function (resolve) {
                    function check() {
                        var A2 = globalThis.__dheeAudio;
                        if (!A2 || A2.gen !== gen) { resolve(null); return; }
                        var remaining = A2.next - A2.ctx.currentTime;
                        if (remaining <= 0.02) { resolve(null); return; }
                        setTimeout(check, Math.min(200, Math.max(20, remaining * 1000)));
                    }
                    check();
                });
            })()
            ,
        'com.dhee.shared.platform.audioStop' : () => {
                var A = globalThis.__dheeAudio;
                if (!A) return;
                A.gen++;
                for (var i = 0; i < A.sources.length; i++) { try { A.sources[i].stop(); } catch (e) {} }
                A.sources = [];
                A.next = 0;
            },
        'com.dhee.shared.platform.audioTones' : (freqsCsv, dursCsv, amp) => {
                var A = globalThis.__dheeAudio;
                if (!A) return;
                var fs = freqsCsv.split(',').map(Number);
                var ds = dursCsv.split(',').map(Number);
                var sr = A.ctx.sampleRate;
                var total = 0; for (var i = 0; i < ds.length; i++) total += Math.floor(ds[i] * sr / 1000);
                if (total <= 0) return;
                var buf = A.ctx.createBuffer(1, total, sr);
                var ch = buf.getChannelData(0);
                var idx = 0;
                for (var i = 0; i < fs.length; i++) {
                    var len = Math.floor(ds[i] * sr / 1000);
                    var twoPiF = 2 * Math.PI * fs[i];
                    var fade = Math.floor(sr * 0.012);
                    for (var n = 0; n < len; n++) {
                        var env = n < fade ? (n / fade) : (n > len - fade ? (len - n) / fade : 1);
                        ch[idx++] = (Math.sin(twoPiF * n / sr) + Math.sin(twoPiF * 2 * n / sr) * 0.33) * env * amp;
                    }
                }
                var src = A.ctx.createBufferSource();
                src.buffer = buf;
                src.connect(A.ctx.destination);
                src.start();
            },
        'com.dhee.shared.platform.jsUint8' : (size) => new Uint8Array(size),
        'com.dhee.shared.platform.jsSetByte' : (a, i, b) => { a[i] = b; },
        'com.dhee.shared.platform.isLocalHost' : () => (function(){ var h = (typeof location !== 'undefined' && location.hostname) ? location.hostname : ''; return h === 'localhost' || h === '127.0.0.1' || h === '[::1]'; })(),
        'com.dhee.shared.platform.callStart' : () => {
                var Ctx = globalThis.AudioContext || globalThis.webkitAudioContext;
                if (!Ctx || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return false;
                var old = globalThis.__dheeCall;
                if (old && old.stop) { try { old.stop(); } catch (e) {} }
                var C = globalThis.__dheeCall = { q: [], sig: [], pending: [], pBytes: 0, gather: null, next: 0, written: 0, segs: [], sources: [], frames: 0, gotAt: 0, active: true };
                C.ctx = new Ctx();
                if (C.ctx.state === 'suspended') { try { C.ctx.resume(); } catch (e) {} }
                C.ctx.onstatechange = function () {
                    if (!C.active) return;
                    if (C.ctx.state === 'interrupted') C.sig.push('interrupted');
                    else if (C.ctx.state === 'running' && C.wasInterrupted) C.sig.push('resumed');
                    C.wasInterrupted = (C.ctx.state === 'interrupted');
                };
                C.stop = function () {
                    C.active = false;
                    if (C.gather) { clearTimeout(C.gather); C.gather = null; }
                    for (var i = 0; i < C.sources.length; i++) { try { C.sources[i].stop(); } catch (e) {} }
                    C.sources = []; C.pending = []; C.pBytes = 0; C.segs = []; C.q = [];
                    try { if (C.node) C.node.disconnect(); } catch (e) {}
                    try { if (C.src) C.src.disconnect(); } catch (e) {}
                    try { if (C.stream) C.stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
                    try { C.ctx.close(); } catch (e) {}
                    if (globalThis.__dheeCall === C) globalThis.__dheeCall = null;
                };
                navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1, echoCancellation: true, noiseSuppression: true, autoGainControl: true } })
                .then(function (stream) {
                    if (!C.active) { try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {} return; }
                    var ctx = C.ctx;
                    if (ctx.state === 'suspended') { try { ctx.resume(); } catch (e) {} }
                    var src = ctx.createMediaStreamSource(stream);
                    var node = ctx.createScriptProcessor(4096, 1, 1);
                    var ratio = ctx.sampleRate / 16000;
                    node.onaudioprocess = function (e) {
                        if (!C.active) return;
                        var input = e.inputBuffer.getChannelData(0);
                        var outLen = Math.floor(input.length / ratio);
                        if (outLen <= 0) return;
                        var out = new Uint8Array(outLen * 2);
                        for (var i = 0; i < outLen; i++) {
                            // Box average over the source samples this output sample covers (no aliasing hiss).
                            var a = Math.floor(i * ratio), b = Math.floor((i + 1) * ratio); if (b <= a) b = a + 1;
                            var s = 0; for (var k = a; k < b; k++) s += input[k]; s = s / (b - a);
                            if (s > 1) s = 1; else if (s < -1) s = -1;
                            var v = (s < 0 ? s * 32768 : s * 32767) | 0;
                            out[i * 2] = v & 0xFF; out[i * 2 + 1] = (v >> 8) & 0xFF;
                        }
                        C.frames++;
                        C.q.push(out);
                    };
                    // The ScriptProcessor must sit in the graph to fire; its unwritten output is silence.
                    src.connect(node); node.connect(ctx.destination);
                    C.stream = stream; C.src = src; C.node = node; C.gotAt = Date.now();
                    stream.getAudioTracks().forEach(function (t) { t.onended = function () { if (C.active) C.sig.push('mic_read_error:ended'); }; });
                })
                .catch(function (err) {
                    var name = (err && err.name) || String(err);
                    C.sig.push(name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError' ? 'mic_denied' : 'mic_unavailable:' + name);
                });
                return true;
            },
        'com.dhee.shared.platform.callHeadSample' : () => {
                var C = globalThis.__dheeCall; if (!C || C.segs.length === 0) return 0;
                var t = C.ctx.currentTime, seg = null;
                for (var i = C.segs.length - 1; i >= 0; i--) { if (C.segs[i].t <= t) { seg = C.segs[i]; break; } }
                if (!seg) return C.segs[0].s;
                var off = Math.floor((t - seg.t) * 24000);
                return seg.s + (off < seg.n ? off : seg.n);
            },
        'com.dhee.shared.platform.callDrainMic' : () => { var C = globalThis.__dheeCall; if (!C || C.q.length === 0) return null; var a = C.q; C.q = []; return a; },
        'com.dhee.shared.platform.jsArrLen_1' : (a) => a.length,
        'com.dhee.shared.platform.jsArrAt_1' : (a, i) => a[i],
        'com.dhee.shared.platform.callDrainSignals' : () => {
                var C = globalThis.__dheeCall; if (!C) return null;
                if (C.gotAt && C.frames === 0 && !C.silentSent && Date.now() - C.gotAt > 3000) { C.silentSent = true; C.sig.push('mic_silent_start'); }
                if (C.sig.length === 0) return null; var a = C.sig; C.sig = []; return a;
            },
        'com.dhee.shared.platform.jsStrAt' : (a, i) => String(a[i]),
        'com.dhee.shared.platform.callEnqueue' : (u8) => {
                var C = globalThis.__dheeCall; if (!C || !C.active) return;
                var ctx = C.ctx;
                if (ctx.state === 'suspended') { try { ctx.resume(); } catch (e) {} }
                function schedule(bytes) {
                    var n = bytes.length >> 1; if (n <= 0) return;
                    var buf = ctx.createBuffer(1, n, 24000);
                    var ch = buf.getChannelData(0);
                    for (var i = 0; i < n; i++) { var s = (bytes[i * 2 + 1] << 8) | bytes[i * 2]; if (s >= 32768) s -= 65536; ch[i] = s / 32768; }
                    var src = ctx.createBufferSource(); src.buffer = buf; src.connect(ctx.destination);
                    var t = ctx.currentTime;
                    var at = C.next > t ? C.next : (t + 0.04);
                    src.start(at);
                    C.segs.push({ t: at, s: C.written, n: n });
                    C.written += n; C.next = at + buf.duration;
                    C.sources.push(src);
                    src.onended = function () { var i = C.sources.indexOf(src); if (i >= 0) C.sources.splice(i, 1); };
                    while (C.segs.length > 1 && C.segs[1].t + 2 < t) C.segs.shift();
                }
                function flushPending() {
                    if (C.gather) { clearTimeout(C.gather); C.gather = null; }
                    var p = C.pending; C.pending = []; C.pBytes = 0;
                    for (var i = 0; i < p.length; i++) schedule(p[i]);
                }
                C.pending.push(u8); C.pBytes += u8.length;
                if (C.next > ctx.currentTime + 0.02) { flushPending(); return; }
                // Caught up: ~300 ms (14400 bytes) of jitter cover, 350 ms at most.
                if (C.pBytes >= 14400) flushPending();
                else if (!C.gather) C.gather = setTimeout(function () { C.gather = null; if (C.active) flushPending(); }, 350);
            },
        'com.dhee.shared.platform.callFlush' : () => {
                var C = globalThis.__dheeCall; if (!C) return 0;
                if (C.gather) { clearTimeout(C.gather); C.gather = null; }
                C.pending = []; C.pBytes = 0;
                for (var i = 0; i < C.sources.length; i++) { try { C.sources[i].stop(); } catch (e) {} }
                C.sources = []; C.segs = []; C.next = 0;
                return C.written;
            },
        'com.dhee.shared.platform.callDrained' : () => { var C = globalThis.__dheeCall; if (!C) return true; return C.pending.length === 0 && C.next <= C.ctx.currentTime + 0.02; },
        'com.dhee.shared.platform.callStop' : () => { var C = globalThis.__dheeCall; if (C && C.stop) C.stop(); },
        'com.dhee.shared.platform.jsU8Len_1' : (u8) => u8.length,
        'com.dhee.shared.platform.jsU8Get_1' : (u8, i) => u8[i],
        'com.dhee.shared.platform.jsUint8_1' : (size) => new Uint8Array(size),
        'com.dhee.shared.platform.jsSetByte_1' : (a, i, b) => { a[i] = b; },
        'com.dhee.shared.platform.webPushPermission' : () => {
                try {
                    if (typeof Notification === 'undefined' || !('serviceWorker' in navigator)) return 'unsupported';
                    if (typeof firebase === 'undefined' || !firebase.messaging || !firebase.messaging.isSupported || !firebase.messaging.isSupported()) return 'unsupported';
                    return Notification.permission;
                } catch (e) { return 'unsupported'; }
            },
        'com.dhee.shared.platform.webPushTokenDone' : () => { var P = globalThis.__dheePush; return !!(P && P.tokenDone); },
        'com.dhee.shared.platform.webPushToken' : () => { var P = globalThis.__dheePush; return (P && P.token) ? P.token : ''; },
        'com.dhee.shared.platform.webPushDeleteStart' : () => {
                var P = globalThis.__dheePush = globalThis.__dheePush || {};
                P.deleteDone = false;
                try { firebase.messaging().deleteToken().then(function () { P.deleteDone = true; }, function () { P.deleteDone = true; }); }
                catch (e) { P.deleteDone = true; }
            },
        'com.dhee.shared.platform.webPushDeleteDone' : () => { var P = globalThis.__dheePush; return !!(P && P.deleteDone); },
        'com.dhee.shared.platform.webPushRequestStart' : () => {
                var P = globalThis.__dheePush = globalThis.__dheePush || {};
                P.requestDone = false;
                try {
                    Notification.requestPermission().then(function () { P.requestDone = true; }, function () { P.requestDone = true; });
                } catch (e) { P.requestDone = true; }
            },
        'com.dhee.shared.platform.webPushRequestDone' : () => { var P = globalThis.__dheePush; return !!(P && P.requestDone); },
        'com.dhee.shared.platform.webPushTokenStart' : (vapidKey) => {
                var P = globalThis.__dheePush = globalThis.__dheePush || {};
                P.tokenDone = false; P.token = '';
                try {
                    navigator.serviceWorker.register('/sw.js', { scope: '/' })
                      .then(function (reg) { return navigator.serviceWorker.ready.then(function () { return reg; }); })
                      .then(function (reg) { return firebase.messaging().getToken({ serviceWorkerRegistration: reg, vapidKey: vapidKey }); })
                      .then(function (t) { P.token = t || ''; P.tokenDone = true; },
                            function (e) { P.token = ''; P.tokenDone = true; console.warn('[dhee] push token', e && e.code ? e.code : e); });
                } catch (e) { P.token = ''; P.tokenDone = true; }
            },
        'com.dhee.shared.platform.webPushClickTag' : () => {
                try { var h = location.hash || ''; return h.indexOf('#dpush=') === 0 ? h.substring(7) : ''; } catch (e) { return ''; }
            },
        'com.dhee.shared.platform.webPushClearClickTag' : () => { try { if ((location.hash || '').indexOf('#dpush=') === 0) history.replaceState(null, '', location.pathname + location.search); } catch (e) {} },
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.clipboard_$external_prop_getter' : (_this) => _this.clipboard,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
        'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
        'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
        'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'com.dheelearn.openOutsidePage' : (url) => (function(u){ try { var w = window.open(u, '_blank', 'noopener'); if (!w) { location.href = u; } return true; } catch (e) { return false; } })(url),
        'com.dheelearn.notifyWebSplashReady' : () => (function(){ try { if (globalThis.__dheeAppReady) { globalThis.__dheeAppReady(); } return true; } catch (e) { return false; } })(),
        'com.dheelearn.media.pickOpen' : (capture) => {
                var P = globalThis.__dheePick || (globalThis.__dheePick = {});
                P.result = null; P.done = false;
                var inp = document.createElement('input');
                inp.type = 'file'; inp.accept = 'image/*';
                if (capture) inp.setAttribute('capture', 'environment');
                inp.style.display = 'none'; document.body.appendChild(inp);
                var finish = function (r) { if (P.done) return; P.result = r; P.done = true; if (inp.parentNode) inp.parentNode.removeChild(inp); };
                inp.addEventListener('change', function () {
                    var f = inp.files && inp.files[0]; if (!f) { finish(null); return; }
                    var url = URL.createObjectURL(f); var img = new Image();
                    img.onload = function () {
                        try {
                            var max = 1600, w = img.naturalWidth, h = img.naturalHeight, s = Math.min(1, max / Math.max(w, h));
                            var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w * s)); c.height = Math.max(1, Math.round(h * s));
                            c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
                            var d = c.toDataURL('image/jpeg', 0.85); URL.revokeObjectURL(url);
                            finish({ b64: d.substring(d.indexOf(',') + 1) });
                        } catch (e) { finish(null); }
                    };
                    img.onerror = function () { URL.revokeObjectURL(url); finish(null); };
                    img.src = url;
                });
                inp.addEventListener('cancel', function () { finish(null); });
                // Older browsers fire nothing on a cancelled dialog: when the window regains focus with no file chosen, give up.
                var onFocus = function () { window.removeEventListener('focus', onFocus); setTimeout(function () { if (!(inp.files && inp.files.length)) finish(null); }, 1500); };
                window.addEventListener('focus', onFocus);
                inp.click();
            },
        'com.dheelearn.media.pickDone' : () => !!(globalThis.__dheePick && globalThis.__dheePick.done),
        'com.dheelearn.media.pickB64' : () => (globalThis.__dheePick && globalThis.__dheePick.result) ? globalThis.__dheePick.result.b64 : null,
        'com.dheelearn.share.webOpen' : (url) => { window.open(url, '_blank', 'noopener,noreferrer'); },
        'com.dheelearn.share.webEncodeURIComponent' : (s) => encodeURIComponent(s),
        'com.dheelearn.share.webShareOrCopy' : (text) => (function(){ if (navigator.share) { navigator.share({ text: text }); return 'share'; } else if (navigator.clipboard) { navigator.clipboard.writeText(text); return 'copy'; } return 'none'; })(),
        'com.dheelearn.ui.common.takeBackPending' : () => (function(){ if (globalThis.__dheeBackPending) { globalThis.__dheeBackPending = false; return true; } return false; })(),
        'com.dheelearn.ui.components.webInstallState' : () => {
                var I = globalThis.__dheeInstall; if (!I) return 'none';
                if (I.installed) return 'installed';
                if (I.evt) return 'prompt';
                if (I.safari) return 'safari';
                return 'none';
            },
        'com.dheelearn.ui.components.webInstallPrompt' : () => { var I = globalThis.__dheeInstall; if (I && I.prompt) I.prompt(); },
        'com.dheelearn.ui.components.webCopyText' : (text) => {
                try { if (!navigator.clipboard || !navigator.clipboard.writeText) return false;
                      navigator.clipboard.writeText(text); return true; } catch (e) { return false; }
            },
        'com.dheelearn.ui.components.webPhoneOs' : () => (globalThis.__dheePhone && globalThis.__dheePhone.os) ? globalThis.__dheePhone.os : null,
        'com.dheelearn.ui.components.webPhoneNudgeDismissed' : () => { var P = globalThis.__dheePhone; return !!(P && P.dismissed && P.dismissed()); },
        'com.dheelearn.ui.components.webPhoneNudgeDismiss' : (days) => { var P = globalThis.__dheePhone; if (P && P.dismiss) P.dismiss(days); },
        'com.dheelearn.ui.plan.planFrameOpen' : (url) => (function(u){ try {
              var g = globalThis;
              var f = g.__dheePlanFrame || (g.__dheePlanFrame = { event: null, el: null });
              if (!f.listening) {
                f.listening = true;
                window.addEventListener('message', function (e) {
                  var f = g.__dheePlanFrame; if (!f || !f.el) return;
                  if (e.origin !== 'https://www.dheelearn.com' && e.origin !== 'https://dheelearn.com') return;
                  var fr = f.el.querySelector('iframe'); if (!fr || e.source !== fr.contentWindow) return;
                  var d = e.data; if (d && d.dhee === 'plan' && typeof d.event === 'string') { f.event = d.event; }
                });
              }
              if (f.el) { var cur = f.el.querySelector('iframe'); if (cur && cur.src === u) { return true; } f.el.remove(); f.el = null; }
              var host = document.createElement('div'); host.id = 'dhee-plan-frame';
              host.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:' + (f.left || 0) + 'px;z-index:2147482000;background:#EDE4F6;';
              var fr = document.createElement('iframe'); fr.src = u;
              fr.setAttribute('allow', 'payment *; clipboard-write'); fr.setAttribute('title', 'Dhee programs');
              fr.style.cssText = 'border:0;width:100%;height:100%;display:block;background:#EDE4F6;';
              host.appendChild(fr); document.documentElement.appendChild(host);
              f.el = host; f.event = null;
              return true;
            } catch (e) { return false; } })(url),
        'com.dheelearn.ui.plan.planFrameInset' : (leftPx) => (function(l){ try { var g = globalThis; var f = g.__dheePlanFrame || (g.__dheePlanFrame = { event: null, el: null }); f.left = l; if (f.el) { f.el.style.left = l + 'px'; } return true; } catch (e) { return false; } })(leftPx),
        'com.dheelearn.ui.plan.planFrameClose' : () => (function(){ try { var f = globalThis.__dheePlanFrame; if (f && f.el) { f.el.remove(); f.el = null; } if (f) { f.event = null; } return true; } catch (e) { return false; } })(),
        'com.dheelearn.ui.plan.planFrameTake' : () => (function(){ var f = globalThis.__dheePlanFrame; if (!f || !f.event) return null; var e = f.event; f.event = null; return e; })(),
        'com.dheelearn.ui.web.webFrameOpen' : (url) => (function(u){ try {
              var g = globalThis;
              var f = g.__dheeWebFrame || (g.__dheeWebFrame = { el: null, fr: null, q: [], origin: null, box: null });
              // The listener is keyed by its own flag, NOT by the state object's existence: layout (onGloballyPositioned) and
              // the trace create the state object before the first open, and the first live build lost every page message.
              if (!f.listening) {
                f.listening = true;
                window.addEventListener('message', function (e) {
                  var f = g.__dheeWebFrame; if (!f || !f.fr) return;
                  if (e.origin !== 'https://www.dheelearn.com' && e.origin !== 'https://dheelearn.com') return;
                  if (e.source !== f.fr.contentWindow) return;
                  var d = e.data; if (!d) return;
                  if (d.dhee === 'bridge' && typeof d.id === 'string' && typeof d.name === 'string') {
                    f.q.push({ kind: 'call', id: d.id, name: d.name, args: typeof d.args === 'string' ? d.args : '{}' });
                  } else if (d.dhee === 'frame' && d.event === 'not_found') {
                    f.q.push({ kind: 'not_found' });
                  }
                });
              }
              if (f.el) { if (f.fr && f.fr.src === u) { return true; } f.el.remove(); f.el = null; f.fr = null; }
              f.q = [];
              f.origin = new URL(u).origin;
              var host = document.createElement('div'); host.id = 'dhee-web-frame';
              var b = f.box || { l: 0, t: 0, w: 0, h: 0 };
              host.style.cssText = 'position:fixed;left:' + b.l + 'px;top:' + b.t + 'px;width:' + b.w + 'px;height:' + b.h + 'px;z-index:2147481000;background:#FBF8FF;overflow:hidden;';
              var fr = document.createElement('iframe'); fr.src = u;
              fr.setAttribute('allow', 'clipboard-write'); fr.setAttribute('title', 'Dhee');
              fr.style.cssText = 'border:0;width:100%;height:100%;display:block;background:#FBF8FF;';
              fr.addEventListener('load', function () { f.q.push({ kind: 'load' }); });
              host.appendChild(fr); document.documentElement.appendChild(host);
              f.el = host; f.fr = fr;
              return true;
            } catch (e) { return false; } })(url),
        'com.dheelearn.ui.web.webFrameLayout' : (left, top, width, height) => (function(l, t, w, h){ try {
              var g = globalThis; var f = g.__dheeWebFrame || (g.__dheeWebFrame = { el: null, fr: null, q: [], origin: null, box: null });
              f.box = { l: l, t: t, w: w, h: h };
              if (f.el) { f.el.style.left = l + 'px'; f.el.style.top = t + 'px'; f.el.style.width = w + 'px'; f.el.style.height = h + 'px'; }
              return true;
            } catch (e) { return false; } })(left, top, width, height),
        'com.dheelearn.ui.web.webFrameClose' : () => (function(){ try { var f = globalThis.__dheeWebFrame; if (f) { if (f.el) { f.el.remove(); } f.el = null; f.fr = null; f.q = []; } return true; } catch (e) { return false; } })(),
        'com.dheelearn.ui.web.webFrameTake' : () => (function(){ var f = globalThis.__dheeWebFrame; if (!f || !f.q || f.q.length === 0) return null; return JSON.stringify(f.q.shift()); })(),
        'com.dheelearn.ui.web.webFrameResolve' : (id, resultJson) => (function(i, r){ try { var f = globalThis.__dheeWebFrame; if (!f || !f.fr || !f.fr.contentWindow) return false; f.fr.contentWindow.postMessage({ dhee: 'bridge', id: i, result: r }, f.origin || 'https://www.dheelearn.com'); return true; } catch (e) { return false; } })(id, resultJson),
        'com.dheelearn.ui.web.webFrameLog' : (line) => (function(s){ try { var g = globalThis; var f = g.__dheeWebFrame || (g.__dheeWebFrame = { el: null, fr: null, q: [], origin: null, box: null }); (f.log || (f.log = [])).push(s); if (f.log.length > 50) f.log.shift(); return true; } catch (e) { return false; } })(line)
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './DheeAI-composeApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./DheeAI-composeApp.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
